export const Version = "2024.05";
export const ExpectedCloudConnectorVersion = "2024.05";
